import type { CategoryConfig } from 'emoji-picker-react';

import { EMOJI_CATEGORIES, EMOJI_CATEGORY_NAMES_EN } from './EmojiPanel.constants';

export const getEmojiCategories = (): CategoryConfig[] =>
  EMOJI_CATEGORIES.map((category) => ({
    category,
    name: EMOJI_CATEGORY_NAMES_EN[category],
  }));
